import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DELIVERY_SHIP_TEXT, DELIVERY_AVAILABLE, DELIVERY_CODES } from './constants';
import { hasDeliveryRestrictions } from './helper';

/**
 * Returns ship text for National SRP and common SRP.
 * @param {string} deliveryCode
 * @param {string} zipCode
 * @param {string} stateCode
 * @param {boolean} isNational
 * @returns {string}
 */
function getDeliveryShipText(deliveryCode, zipCode, stateCode, isNational) {
  if (isNational) {
    return `${DELIVERY_SHIP_TEXT[`${deliveryCode}_NTL`]}`;
  } else if (hasDeliveryRestrictions(stateCode)) {
    return DELIVERY_AVAILABLE;
  }

  return `${DELIVERY_SHIP_TEXT[deliveryCode]} ${zipCode}`;
}

/**
 * Shows delivery text:
 * - 'Ship to {zipCode}' text for common SRP;
 * - 'Delivery Available' text when user's state has restrictions (e.g. Hawaii);
 * - '(Free) Delivery available' text for National SRP.
 * @param {string} deliveryCode
 * @param {string} zipCode
 * @param {string} classes
 * @param {string} stateCode
 * @param {string} footnoteSymbol
 * @param {boolean} isNational
 * @returns {ReactElement}
 */
export function DeliveryToZip({
  isNational = false,
  deliveryCode = '',
  zipCode = '',
  classes = '',
  stateCode = '',
  footnoteSymbol = '',
}) {
  if (!DELIVERY_CODES.includes(deliveryCode) || !zipCode) return null;

  const deliveryText = getDeliveryShipText(deliveryCode, zipCode, stateCode, isNational);

  return (
    <div className={classNames('d-inline-block bg-gray-extra-light small text-gray-darker', classes)}>
      <span className="icon-transit me-0_25" title="Shipping" /> {deliveryText}
      {!!footnoteSymbol && <sup>{footnoteSymbol}</sup>}
    </div>
  );
}

DeliveryToZip.propTypes = {
  deliveryCode: PropTypes.string,
  zipCode: PropTypes.string,
  stateCode: PropTypes.string,
  classes: PropTypes.string,
  footnoteSymbol: PropTypes.string,
  isNational: PropTypes.bool,
};
